/* tslint:disable */
/* eslint-disable */
/**
 * Melco Reporting APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ReportingMelcoModelsError,
    ReportingMelcoModelsErrorFromJSON,
    ReportingMelcoModelsErrorToJSON,
    ReportingMelcoModelsGenericList1MelcoMachineStatisticsModelsMachineDesignListItem,
    ReportingMelcoModelsGenericList1MelcoMachineStatisticsModelsMachineDesignListItemFromJSON,
    ReportingMelcoModelsGenericList1MelcoMachineStatisticsModelsMachineDesignListItemToJSON,
} from '../models';

export interface MachineDesignsApiMachineDesignsSearchRequest {
    offset?: number;
    limit?: number;
    sortBy?: string;
    searchText?: string;
}

/**
 * 
 */
export class MachineDesignsApi extends runtime.BaseAPI {

    /**
     */
    async machineDesignsSearchRaw(requestParameters: MachineDesignsApiMachineDesignsSearchRequest): Promise<runtime.ApiResponse<ReportingMelcoModelsGenericList1MelcoMachineStatisticsModelsMachineDesignListItem>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sort_by'] = requestParameters.sortBy;
        }

        if (requestParameters.searchText !== undefined) {
            queryParameters['search_text'] = requestParameters.searchText;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/machines/designs`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ReportingMelcoModelsGenericList1MelcoMachineStatisticsModelsMachineDesignListItemFromJSON(jsonValue));
    }

    /**
     */
    async machineDesignsSearch(requestParameters: MachineDesignsApiMachineDesignsSearchRequest): Promise<ReportingMelcoModelsGenericList1MelcoMachineStatisticsModelsMachineDesignListItem> {
        const response = await this.machineDesignsSearchRaw(requestParameters);
        return await response.value();
    }

}
